<template>
    <div>
        <Header v-if="!$route.meta.isHideHAndF" />
        <router-view />
        <Footer v-if="!$route.meta.isHideHAndF" />
    </div>
</template>
<script>
import Header from '@/components/Header/';
import Footer from '@/components/Footer/';
import { mapActions } from 'vuex';
export default {
    name: 'App',
    components: {
        Footer,
        Header,
    },
    methods: {
        ...mapActions('types', ['getTypeList']),
        ...mapActions('region', ['getRegionList']),
    },
    data() {
        return {};
    },
    mounted() {
        this.getTypeList();
        this.getRegionList();
    },
};
</script>
<style lang="less"></style>
